import React from 'react';
import { SvgIcon } from '../../components';

interface ToolsIconProps {
  w?: string;
  h?: string;
}

export const ToolsIcon = ({ w, h }: ToolsIconProps) => {
  return (
    <SvgIcon width={w || '50'} height={h || '50'} viewBox="0 0 50 50">
      {/* Toolbox body */}
      <rect
        x="9"
        y="18"
        width="32"
        height="20"
        rx="3"
        ry="3"
        fill="none"
        stroke="#5D6465"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* Handle */}
      <path
        d="M19 18v-3c0-1.8 1.5-3.3 3.3-3.3h5.4c1.8 0 3.3 1.5 3.3 3.3v3"
        fill="none"
        stroke="#5D6465"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* Lid separation line */}
      <path
        d="M11 24h12.5M39 24H26.5"
        fill="none"
        stroke="#5D6465"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* Center latch */}
      <rect x="22.5" y="24" width="5" height="7" rx="1" ry="1" fill="#5D6465" />
    </SvgIcon>
  );
};
